var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          Пакетная проверка — решение для разовой проверки большого количества\n          субъектов.\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "title"
    }
  }, [_vm._v("Пакетные запросы можно использовать в следующих сценариях:")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('ul', [_c('li', [_vm._v("Проверка скоринга")]), _vm._v(" "), _c('li', [_vm._v("Проверка кредитного рейтинга")]), _vm._v(" "), _c('li', [_vm._v("Постановка на мониторинг")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "title"
    }
  }, [_vm._v("Преимущества пакетных проверок:")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('ol', [_c('li', [_vm._v("Результаты представлены в виде агрегированной таблицы.")]), _vm._v(" "), _c('li', [_vm._v("\n            Аналитика выборки, субъекты сегментированы по категориям риска.\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            Стоимость ниже, чем если бы вы проверяли каждого субъекта вручную.\n          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          Свяжитесь с нами, чтобы получить подробную информацию о ценах и вариантах использования пакетных проверок в Unirate 24.\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.left",
      modifiers: {
        "left": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.requestPackage
    }
  }, [_vm._v(" Оставить заявку ")])], 1)])]), _vm._v(" "), _c('v-modal', {
    attrs: {
      "active": _vm.isShowConfirm
    },
    on: {
      "close": function($event) {
        _vm.isShowConfirm = false
      }
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "type": "title"
    }
  }, [_vm._v(" Спасибо ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "type": "title"
    }
  }, [_vm._v("\n          Ваша заявка принята\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_vm._v("\n          Мы свяжемся с вами в ближайшее время.\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" Закрыть ")])], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e573fd0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/packageRequest/PackageRequest.vue
// module id = 1024
// module chunks = 0